<template>
    <v-container class="py-0">
        <v-row>
            <v-col
                cols="12"
                id="chart"
                ref="chart"
                class="text-center pl-0 py-0 pr-0"
                v-if="!loading && chartData"
            >
                <PlayerAvatarMedia v-if="chartData.mediaMode && chartData.category != 'game'"
                    :player="chartData.player || {}" :width="chartData.size" :height="chartData.size * 0.12" :id="chartData.id"
                    :key="chartData.playerAvatarMediaKey" :margin="chartData.margin" :title="mediaModeData.upperText" :subtitle="mediaModeData.lowerText"
                    :color="mediaModeData.borderColor" ref="playerAvatarMediaRef" :bgColor="mediaModeData.bgColor" :textColor="mediaModeData.textColor"
                    :comparisonPlayerData="chartData.comparePlayerData" :comparisonTitle="mediaModeData.comparisonUpperText" :comparisonSubtitle="mediaModeData.comparisonLowerText" :comparisonColor="mediaModeData.comparisonBorderColor"
                    :type="chartData.selectedTab" :face="mediaModeData.face.dataUrl" :comparisonFace="mediaModeData.comparisonFace ? mediaModeData.comparisonFace.dataUrl : null"
                    :lineDistance="mediaModeData.lineLength" :lineWeight="mediaModeData.lineWeight" :avatarSize="mediaModeData.avatarSize"
                    :upperTextFontSize="mediaModeData.upperTextFontSize" :upperTextFontWeight="mediaModeData.upperTextFontWeight"
                    :lowerTextFontSize="mediaModeData.lowerTextFontSize" :lowerTextFontWeight="mediaModeData.lowerTextFontWeight"
                    embed
                    :teamMode="chartData.teamMode"
                    :team="chartData.team"
                />
                <GameAvatarMedia v-if="chartData.mediaMode && chartData.category === 'game'" :width="chartData.size" :height="chartData.size * 0.12" :id="mediaModeData.id" :game="chartData.game"
                    :margin="chartData.margin" :titleLeft="mediaModeData.titleLeft" :titleRight="mediaModeData.titleRight"
                    :leftColor="isWhite(mediaModeData.leftFillColor) ? mediaModeData.leftBorderColor : mediaModeData.leftFillColor"
                    :rightColor="isWhite(mediaModeData.rightFillColor) ? mediaModeData.rightBorderColor : mediaModeData.rightFillColor"
                    ref="gameAvatarMediaRef" :bgColor="mediaModeData.bgColor" :textColor="mediaModeData.textColor"
                    :key="chartData.playerAvatarMediaKey"
                    :type="chartData.selectedTab" :lineDistance="mediaModeData.lineLength" :avatarSize="mediaModeData.avatarSize" :lineWeight="mediaModeData.lineWeight"
                    :titleFontSize="mediaModeData.titleFontSize" :titleFontWeight="mediaModeData.titleFontWeight"
                    :subtitle="mediaModeData.subtitle" :subtitleFontSize="mediaModeData.subtitleFontSize" :subtitleFontWeight="mediaModeData.subtitleFontWeight"
                    :subtitle2="mediaModeData.subtitle2" :subtitle2FontSize="mediaModeData.subtitle2FontSize" :subtitle2FontWeight="mediaModeData.subtitle2FontWeight"
                    embed
                />
                <RadarChart
                    v-if="chartData.chartType === 'radar'"
                    :size="chartData.size"
                    :margin="chartData.margin"
                    :radarData="chartData.radarData"
                    :darkMode="chartData.darkMode"
                    :dataPer90MinText="chartData.dataPer90MinText"
                    :adjustToPossessionText="chartData.adjustToPossessionText"
                    :playerName="chartData.playerName"
                    :radarTitle="chartData.radarTitle"
                    :yob="chartData.yob"
                    :comparePlayerData="chartData.comparePlayerData"
                    :key="chartData.key"
                    :mediaMode="chartData.mediaMode"
                    :colors="chartData.colors"
                    :bgColor="chartData.bgColor"
                    :textColor="chartData.textColor"
                    :axisColor="chartData.axisColor"
                    :logoCfg="chartData.logoCfg"
                    :id="chartData.id"
                    embed
                    v-bind:class="{'mt-1':!chartData.mediaMode}"
                />
                <TeamRadarChart
                    v-if="chartData.chartType === 'radarTeam'"
                    :id="chartData.id"
                    :key="chartData.key"
                    :size="chartData.size"
                    :margin="chartData.margin"
                    :radarData="chartData.radarData"
                    :bottomText="chartData.bottomText"
                    :bottomText2="chartData.bottomText2"
                    :teamName="chartData.teamName"
                    :radarTitle="chartData.radarTitle"
                    :mediaMode="chartData.mediaMode"
                    :colors="chartData.colors"
                    :bgColor="chartData.bgColor"
                    :textColor="chartData.textColor"
                    :axisColor="chartData.axisColor"
                    :logoCfg="chartData.logoCfg"
                    embed
                />
                <PolarChart
                  v-if="chartData.chartType === 'polar'"
                  :id="chartData.id"
                  :size="chartData.size"
                  :margin="chartData.margin"
                  :polarData="chartData.polarData"
                  :darkMode="chartData.darkMode"
                  :dataPer90MinText="chartData.dataPer90MinText"
                  :adjustToPossessionText="chartData.adjustToPossessionText"
                  :playerName="chartData.playerName"
                  :polarTitle="chartData.radarTitle"
                  :yob="chartData.yob"
                  :key="chartData.key"
                  :mediaMode="chartData.mediaMode"
                  :colors="chartData.colors"
                  :bgColor="chartData.bgColor"
                  :textColor="chartData.textColor"
                  :axisColor="chartData.axisColor"
                  :logoCfg="chartData.logo"
                  embed
                  v-bind:class="{'mt-1':!chartData.mediaMode}"
                />
                <LollipopChart
                  v-if="chartData.lollipopData && !chartData.lollipopData.statDTOs[1] && chartData.size != 0 && chartData.chartType === 'lollipop'"
                  :id="chartData.id"
                  :size="chartData.size"
                  :key="chartData.key"
                  :chartData="chartData.lollipopData"
                  :dataPer90MinText="chartData.dataPer90MinText"
                  :adjustToPossessionText="chartData.adjustToPossessionText"
                  :playerName="chartData.player.name"
                  :radarTitle="chartData.radarTitle"
                  :yob="chartData.yob"
                  :top5Leagues="chartData.top5Leagues"
                  :mediaMode="chartData.mediaMode"
                  :colors="chartData.colors"
                  :bgColor="chartData.bgColor"
                  :textColor="mediaModeData.textColor"
                  :axisColor="mediaModeData.axisColor"
                  :logoCfg="mediaModeData.logo"
                />
                <CompareLollipopChart
                  v-if="chartData.lollipopData && chartData.lollipopData.statDTOs[1] && chartData.size != 0 && chartData.chartType === 'lollipop'"
                  :id="chartData.id"
                  :size="chartData.size"
                  :key="chartData.key"
                  :chartData="chartData.lollipopData"
                  :dataPer90MinText="chartData.dataPer90MinText"
                  :adjustToPossessionText="chartData.adjustToPossessionText"
                  :playerName="chartData.player.name"
                  :radarTitle="chartData.radarTitle"
                  :yob="chartData.yob"
                  :top5Leagues="chartData.top5Leagues"
                  :mediaMode="chartData.mediaMode"
                  :colors="chartData.colors"
                  :bgColor="chartData.bgColor"
                  :textColor="mediaModeData.textColor"
                  :axisColor="mediaModeData.axisColor"
                  :logoCfg="mediaModeData.logo"
                  :comparePlayerData="chartData.comparePlayerData"
                />
                <TeamLollipopChart
                    v-if="chartData.chartType === 'lollipopTeam' &&  chartData.lollipopData && !chartData.lollipopData.statDTOs[1] && chartData.size != 0"
                    :id="chartData.id"
                    :size="chartData.size"
                    :key="chartData.key"
                    :chartData="chartData.lollipopData"
                    :dataPerGameText="chartData.dataPerGameText"
                    :adjustToPossessionText="chartData.adjustToPossessionText"
                    :teamName="chartData.teamName"
                    :radarTitle="chartData.radarTitle"
                    :minMaxLabel="chartData.minMaxLabel"
                    :mediaMode="chartData.mediaMode"
                    :bgColor="chartData.bgColor"
                    :textColor="chartData.textColor"
                    :axisColor="chartData.axisColor"
                    :logoCfg="chartData.logoCfg"
                    embed
                />
                <CompareTeamLollipopChart
                    v-if="chartData.chartType === 'lollipopTeam' && chartData.lollipopData && chartData.lollipopData.statDTOs[1] && chartData.size != 0"
                    :id="chartData.id"
                    :size="chartData.size"
                    :key="chartData.key"
                    :chartData="chartData.lollipopData"
                    :dataPerGameText="chartData.dataPerGameText"
                    :adjustToPossessionText="chartData.adjustToPossessionText"
                    :teamName="chartData.teamName"
                    :radarTitle="chartData.radarTitle"
                    :minMaxLabel="chartData.minMaxLabel"
                    :compareTeamData="chartData.compareTeamData"
                    :mediaMode="chartData.mediaMode"
                    :colors="chartData.colors"
                    :bgColor="chartData.bgColor"
                    :textColor="chartData.textColor"
                    :axisColor="chartData.axisColor"
                    :logoCfg="chartData.logoCfg"
                    embed
                />
                <div v-if="chartData.chartType === 'beeswarm'" class="mt-6">
                  <Beeswarm
                      v-for="(statObject, index) of chartData.data.stats" :key="chartData.key"
                      :size="chartData.size"
                      :chartData="chartData.data.bees"
                      :playerId="parseInt(chartData.player.playerId)"
                      :playerSeasonInfo="chartData.playerSeasonInfo"
                      :statId="statObject.id"
                      :stat="statObject.code"
                      :reversedStat="statObject.reverse"
                      :statTitle="$t('statsNaming.' + statObject.code)"
                      :statSubtitle="$t('statsNaming.subtitles.' + statObject.code)"
                      :idKey="chartData.idKey"
                      :darkMode="chartData.darkMode"
                      :parentSVG="chartData.parentSVG"
                      :bgColor="chartData.mediaModeData.bgColor"
                      :textColor="chartData.mediaModeData.textColor"
                      :axisColor="chartData.mediaModeData.axisColor"
                      :comparisonPlayer="chartData.mediaModeData.comparisonPlayer"
                      :dotColor="chartData.mediaModeData.borderColor"
                      :comparisonDotColor="chartData.mediaModeData.comparisonBorderColor"
                      :index="index"
                      :mediaMode="chartData.mediaMode"
                      embed
                      ref="beeswarmRef"
                  />
                </div>
                <RaceChart :id="chartData.id" :game="chartData.game" :shotData="chartData.shots" :key="chartData.key"
                v-if="chartData.chartType === 'finishing-map' && chartData.selectedTab === 'chartView'"/>
                <XGChart
                    v-if="chartData.chartType === 'finishing-map' && chartData.selectedTab === 'topView'"
                    :size="chartData.size"
                    :shots="chartData.shots"
                    :circlesAndBoxes="chartData.circlesAndBoxes"
                    :key="chartData.key"
                    :playerPosition="chartData.playerPosition"
                    :playerSeasonData="chartData.playerSeasonData"
                    :playerName="chartData.category != 'game' ? (chartData.teamMode ? chartData.teamName :  chartData.player.name) : ''"
                    :language="chartData.language"
                    :homeFillColor="mediaModeData.homeFillColor"
                    :homeBorderColor="mediaModeData.homeBorderColor"
                    :awayFillColor="mediaModeData.awayFillColor"
                    :awayBorderColor="mediaModeData.awayBorderColor"
                    :homeTeamName="mediaModeData.titleLeft"
                    :awayTeamName="mediaModeData.titleRight"
                    :mediaMode="chartData.mediaMode"
                    :id="chartData.id"
                    :team="chartData.teamMode"
                    :game="chartData.game"
                    :embed="true"
                    ref="xgChart"
                />
                <XGGoalChart
                    v-if="chartData.chartType === 'finishing-map' && chartData.selectedTab === 'frontView'"
                    :size="chartData.size"
                    :shots="chartData.shots"
                    :circlesAndBoxes="chartData.circlesAndBoxes"
                    :key="chartData.key"
                    :playerPosition="chartData.playerPosition"
                    :playerSeasonData="chartData.playerSeasonData"
                    :playerName="chartData.player.name"
                    :language="chartData.language"
                    :homeFillColor="mediaModeData.homeFillColor"
                    :homeBorderColor="mediaModeData.homeBorderColor"
                    :awayFillColor="mediaModeData.awayFillColor"
                    :awayBorderColor="mediaModeData.awayBorderColor"
                    :mediaMode="chartData.mediaMode"
                    :showPenalties="chartData.showPenalties"
                    :id="chartData.id"
                    :team="chartData.team"
                    :gameIds="chartData.gameIds || []"
                    ref="xgChart"
                />
                <FinishingTable v-if="chartData.chartType === 'finishing-map' && chartData.selectedTab === 'distribution'"
                    :id="chartData.id"
                    :shots="chartData.shots"
                    :playerSeasonData="chartData.playerSeasonData"
                    :size="chartData.size"
                    :type="chartData.insightSelected"
                    :key="chartData.key"
                ></FinishingTable>
                <XAChart
                    v-if="chartData.chartType === 'key-pass-map'"
                    :size="chartData.size"
                    :passes="chartData.passes"
                    :type="chartData.type"
                    :key="chartData.key"
                    :playerId="chartData.category != 'game' ? (chartData.teamMode ? chartData.teamId : chartData.player.playerId) : null"
                    :seasons="chartData.playerSeasonData"
                    :playerName="chartData.category != 'game' ? (chartData.teamMode ? chartData.teamName :  chartData.player.name) : ''"
                    :circlesAndBoxes="chartData.circlesAndBoxes"
                    :language="chartData.language"
                    :mediaMode="chartData.mediaMode"
                    :id="chartData.id"
                    :game="chartData.game"
                    :homeFillColor="mediaModeData.leftFillColor"
                    :awayFillColor="mediaModeData.rightFillColor"
                    :homeBorderColor="mediaModeData.leftBorderColor"
                    :awayBorderColor="mediaModeData.rightBorderColor"
                    :homeTeamName="mediaModeData.titleLeft"
                    :awayTeamName="mediaModeData.titleRight"
                    ref="xaChart"
                />
                <XTChart
                    v-if="chartData.chartType === 'xt-map'"
                    :size="chartData.size"
                    :type="chartData.type"
                    :key="chartData.key"
                    :player="chartData.player"
                    :plays="chartData.plays"
                    :minXT="chartData.minXT"
                    :maxXT="chartData.maxXT"
                    :language="chartData.language"
                    :typeOfPlay="chartData.typeOfPlay"
                    :seasons="chartData.playerSeasonData"
                    :playerName="chartData.category != 'game' ? (chartData.teamMode ? chartData.teamName :  chartData.player.name) : ''"
                    :circlesAndBoxes="chartData.circlesAndBoxes"
                    :homeFillColor="mediaModeData.leftFillColor"
                    :awayFillColor="mediaModeData.rightFillColor"
                    :homeBorderColor="mediaModeData.leftBorderColor"
                    :awayBorderColor="mediaModeData.rightBorderColor"
                    :homeTeamName="mediaModeData.titleLeft"
                    :awayTeamName="mediaModeData.titleRight"
                    :mediaMode="chartData.mediaMode"
                    :game="chartData.game"
                    :id="chartData.id"
                />
                <PassMapChart
                    v-if="chartData.chartType === 'game-pass-map'"
                    :size="chartData.size"
                    :key="chartData.key"
                    :passes="chartData.passes"
                    :passesByPlayersName="chartData.passesByPlayersName"
                    :playersAvgPosition="chartData.playersAvgPosition"
                    :teamId="chartData.teamId"
                    :teamFormation="chartData.teamFormation"
                    :teamColor="chartData.teamColor"
                    :strokeColor="chartData.strokeColor"
                    :teamName="chartData.teamName"
                    :minFrom="chartData.minFrom"
                    :minTo="chartData.minTo"
                    :language="chartData.language"
                    :id="chartData.id"
                    :mediaMode="chartData.mediaMode"
                />
                <ZeroLineChart v-if="chartData.chartType === 'game-flow'"
                    :datasets="chartData.datasets"
                    :xAxisLabels="chartData.xAxisLabels"
                    :options="chartData.options"
                    :mediaMode="chartData.mediaMode"
                    :id="chartData.id"
                    ref="xTChartRef"
                />
                <StackedBarChart
                    v-if="chartData.chartType === 'stacked-bar-chart'"
                    :teamId="chartData.teamId"
                    :size="chartData.size"
                    :key="chartData.key"
                    :margin="chartData.margin"
                    :barChartStats="chartData.barChartStats"
                    :language="chartData.language"
                    :isTotal="chartData.isTotal"
                    :printLogo="true"
                    :chartData="chartData.chartData"
                    :teamName="chartData.teamName"
                    class="pt-0"
                />
                <ScatterPlotChart
                  class="mt-3"
                  v-if="chartData.chartType === 'scatter-plot'"
                  :scatterMetrics="chartData.scatterMetrics"
                  :axisX="chartData.axisX"
                  :axisY="chartData.axisY"
                  :size="chartData.size"
                  :seasons="chartData.seasons"
                  :key="chartData.key"
                  :chartType="chartData.scatterType"
                  :bubbleSize="chartData.bubbleSize"
                  :fieldPositions="chartData.positions"
                  :maxAge="Number(chartData.maxAge)"
                  :minMinutes="Number(chartData.minMinutes)"
                  :is90="chartData.is90"
                  id="embed-sp">
                </ScatterPlotChart>
                <EventsChart
                    class="mt-3"
                    v-if="chartData.chartType === 'touches-map'"
                    :events="chartData.events"
                    :size="chartData.size"
                    :chartTypeModel="chartData.chartTypeModel"
                    :visualization="chartData.visualization"
                    :id="chartData.chartId"
                    :key="chartData.key"
                >
                </EventsChart>
                <PossessionChart
                  v-if="chartData.chartType === 'game-possessions-map'"
                  :size="chartData.size"
                  :id="chartData.id"
                  :key="chartData.key"
                  :game="chartData.game"
                  :possession="chartData.possession"
                  :homeFillColor="mediaModeData.leftFillColor"
                  :awayFillColor="mediaModeData.rightFillColor"
                  :homeBorderColor="mediaModeData.leftBorderColor"
                  :awayBorderColor="mediaModeData.rightBorderColor"
                  :homeTeamName="mediaModeData.titleLeft"
                  :awayTeamName="mediaModeData.titleRight"
                  :mediaMode="chartData.mediaMode"
                  :showSequenceNumbers="chartData.sequenceNumbersModel"
                  :showJerseyNumbers="chartData.jerseyNumbersModel"
                />
                <v-card class="pa-2 pa-md-0 pt-md-8" v-if="chartData.chartType === 'ageProfileChart'">
                    <AgeProfileChart class="" :id="chartData.id" :chartData="chartData.chartData"
                        :key="chartData.key"
                        :legendTitle="chartData.legendTitle"
                        :legendSubtitle="chartData.legendSubtitle"
                        :circleColor="chartData.circleColor"
                        :circleSize="chartData.circleSize"
                        :line="chartData.line"></AgeProfileChart>
                </v-card>
                <AttackZonesChart v-if="chartData.chartType === 'attackZonesChart'"
                    :id="chartData.id" :type="chartData.type" :data="chartData.data"
                    :legendTitle="chartData.legendTitle"
                    :legendSubtitle="chartData.legendSubtitle"
                    :key="chartData.key"></AttackZonesChart>
                <CrossingChart v-if="chartData.chartType === 'crossingsChart'"
                    :crossings="chartData.data" :areas="chartData.areas"
                    :size="chartData.size" :id="chartData.id" :circlesAndBoxes="chartData.circlesAndBoxes"
                    :key="chartData.key"
                    :legendTitle="chartData.legendTitle"
                    :legendSubtitle="chartData.legendSubtitle"></CrossingChart>
                <DriblabSocialMedia v-if="chartData.mediaMode && mediaModeData.socialMedia"
                    :width="chartData.size" :height="50" :id="chartData.id"
                    :key="chartData.socialMediaKey" :margin="chartData.margin" ref="driblabSocialMediaRef" :bgColor="mediaModeData.bgColor" :textColor="mediaModeData.textColor"
                    :fontSize="mediaModeData.socialMediaFontSize" :fontWeight="mediaModeData.socialMediaFontWeight"
                    :logoCfg="mediaModeData.logo"
                    :sponsor="mediaModeData.sponsor ? mediaModeData.sponsor.dataUrl : null"
                    :type="chartData.selectedTab" embed
                />
                <LineChart v-if="charts.includes(chartData.chartType)"
                  id="chartData.id"
                  :datasets="chartData.datasets"
                  :xAxisLabels="chartData.labels"
                  :gamesName="chartData.gamesName"
                  :options="chartData.options"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import UserChartService from '../../services/user-chart.service';
import RadarChart from './RadarChart';
import TeamRadarChart from '../team/TeamRadarChart';
import DriblabSocialMedia from './DriblabSocialMedia';
import PlayerAvatarMedia from './../player/PlayerAvatarMedia';
import GameAvatarMedia from './../game/GameAvatarMedia';
import LollipopChart from './LollipopChart';
import CompareLollipopChart from './CompareLollipopChart';
import TeamLollipopChart from '../team/TeamLollipopChart';
import CompareTeamLollipopChart from '../team/CompareTeamLollipopChart';
import PolarChart from './PolarChart';
import Beeswarm from './Beeswarm';
import XGChart from './XGChart';
import XAChart from './XAChart';
import XGGoalChart from './XGGoalChart';
import XTChart from './XTChart';
import PassMapChart from './PassMapChart';
import ZeroLineChart from '../charts/ZeroLineChart';
import StackedBarChart from "./StackedBarChart";
import ScatterPlotChart from "./ScatterPlotChart";
import EventsChart from "./EventsChart";
import PossessionChart from "./PossessionChart";
import FinishingTable from "./FinishingTable";
import AgeProfileChart from "./AgeProfileChart";
import AttackZonesChart from "./AttackZonesChart";
import CrossingChart from "./CrossingChart";
import RaceChart from './RaceChart';
import LineChart from "@/views/charts/LineChart";
import * as chartConfigs from "@/views/charts/config";

  export default {
    name: 'EmbedChart',
    components:{
        RadarChart,
        TeamRadarChart,
        PlayerAvatarMedia,
        DriblabSocialMedia,
        LollipopChart,
        CompareLollipopChart,
        TeamLollipopChart,
        CompareTeamLollipopChart,
        PolarChart,
        Beeswarm,
        XGChart,
        XGGoalChart,
        XAChart,
        XTChart,
        GameAvatarMedia,
        PassMapChart,
        ZeroLineChart,
        StackedBarChart,
        ScatterPlotChart,
        EventsChart,
        PossessionChart,
        FinishingTable,
        AgeProfileChart,
        AttackZonesChart,
        CrossingChart,
        RaceChart,
        LineChart
    },
    computed:{
        chartId(){
            return this.$route.params.chartId
        },
        chartKey(){
            return this.$route.params.key
        },
        componentId(){
            return this.$route.params.componentId
        },
        categoryId(){
            return this.$route.params.categoryId
        },
        toolId(){
            return this.$route.params.toolId
        },
        mediaModeData(){
            return this.chartData.mediaModeData;
        }
    },
    props: {
    },
    created(){
      //When window resize
      window.addEventListener("resize", this.onWindowResize);
    },
    mounted(){

        this.loadData();
    },
    data() {
      return {
          loading:false,
          chartData: null,
          charts: ['npgVsXGChart','xGAgainstvsNPGAgainstChart','pointsVsXPointsChart','xGvsxGAgainstChart']
      }
    },
    watch: {
    },
    methods:{
        async loadData(){
            this.loading= true;
            let dataResponse = await UserChartService.getChartData(this.chartId, this.chartKey, this.componentId, this.categoryId, this.toolId);
            this.chartData = dataResponse.data;
            //Need to overwrite options to allow generateLabels function run successfully
            if(this.chartData.chartType === 'game-flow'){
              this.chartData.options = chartConfigs.ZerolineChartOptions;
            }

            if(this.chartData){
                this.$store.dispatch("auth/setLanguage", this.chartData.language);
            }
            this.loading= false;
            setTimeout(() => this.setSize(),150);
        },
        setSize(){
            if(this.chartData){
                this.chartData.size = this.$refs.chart.clientWidth;

                if(this.chartData.chartType === 'stacked-bar-chart'){
                    let leftRatio = this.chartData.size < 440 ? 0.22 : 0.21;
                    this.chartData.margin = {
                        top: this.chartData.size * 0.05,
                        right: this.chartData.size * 0.2,
                        bottom: 25,
                        left: this.chartData.size * leftRatio,
                    };
                }else{
                    this.chartData.margin = {
                        top: this.chartData.size * 0.13,
                        right: this.chartData.size * 0.2,
                        bottom: 0,
                        left: this.chartData.chartType === 'radarTeam' ? this.chartData.size * 0.2 : 0,
                    };
                }
                this.chartData.key++;
                this.chartData.playerAvatarMediaKey++;
                this.chartData.socialMediaKey++;
                this.chartData = {...this.chartData};
                this.$forceUpdate();

                if(this.chartData.chartType === 'beeswarm' && this.$refs.beeswarmRef){
                    setTimeout(() => this.$refs.beeswarmRef.forEach(r => r.drawBeeswarm()),150);
                }
            }
        },
        onWindowResize(){
            this.setSize();
        },
        isWhite(color){
            return color === "#FFF" || color === "#fff" || color === "#FFFFFF" || color === "#ffffff" || color === "white";
        },
    },
    destroyed(){
        window.removeEventListener("resize",this.onWindowResize);
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/base/EmbedChart.vue